import { Component } from '@angular/core';
import { routes } from '../../consts/routes';
import { menu } from '../../consts/menu'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  public routes: typeof routes = routes;
  public isOpenUiElements = false;

  public infoMenu = menu
  constructor(){

  }

  public openUiElements() {
    this.isOpenUiElements = !this.isOpenUiElements;
  }
}
